// §25.9 / §9.1 — Skipper as an in-process app. Gated (D-200); manifest only (D-247), so the
// engine, the four levels and the renderer all ride the lazy chunk (§24.12).
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const skipperApp: InProcessApp = createLazyApp({
  app: {
    id: 'skipper',
    name: 'Skipper',
    icon: { glyph: 'footprints', hue: 130 },
    keywords: ['platformer', 'jump', 'run', 'mario', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Action',
    requiresAuth: true,
    // Fixed 25:12, letterboxed (D-229). How far ahead a player can see is the level design, so a
    // window that changed it would change every jump the level asks for.
    window: { width: 900, height: 620, minWidth: 600, minHeight: 420, multiWindow: false },
    jumpList: [{ id: 'new-game', label: 'New game' }],
  },
  load: () => import('./Skipper'),
});
